import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup-info" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Email", -1)
const _hoisted_3 = {
  class: "property-lookup-container",
  "data-bind": "dxTextBox: {}"
}
const _hoisted_4 = { class: "popup-info" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Mobile Telephone", -1)
const _hoisted_6 = {
  class: "property-lookup-container",
  "data-bind": "dxTextBox: {}"
}
const _hoisted_7 = { class: "popup-info" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Home Telephone", -1)
const _hoisted_9 = {
  class: "property-lookup-container",
  "data-bind": "dxTextBox: {}"
}
const _hoisted_10 = { class: "popup-info" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Business Telephone", -1)
const _hoisted_12 = {
  class: "property-lookup-container",
  "data-bind": "dxTextBox: {}"
}
const _hoisted_13 = { class: "popup-info" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Alt Telephone", -1)
const _hoisted_15 = {
  class: "property-lookup-container",
  "data-bind": "dxTextBox: {}"
}

import { computed, ref, watch } from "vue";
import modalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import { DxTextBox, DxButton } from "devextreme-vue/text-box";
import { Contacts } from "acquaint-api/models/Contacts";
import { useContactHelper } from "@/utils/contacts/useContactHelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'contacts-peek-popup',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },

  /**
   * The unique identifier for the contact.
   * @type {number}
   * @required
   */
  contactId: {
    type: Number,
    required: true,
  },

  /**
   * The title or heading associated with the component.
   * @type {string}
   * @default: ""
   */
  title: {
    type: String,
    default: "",
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;

const { fetchContactById } = useContactHelper();
const contactData = ref<Contacts>();





const showPeek = computed({
  get: () => props.modelValue,
  set: (value: Boolean) => emit("update:modelValue", value),
});

const closePeek = () => {
  showPeek.value = false;
};

const getContactData = async () => {
  contactData.value = await fetchContactById(props.contactId);
};

//When the peek popup is visible, the data is fetched
watch(
  () => showPeek.value,
  async () => {
    if (!showPeek.value) {
      return;
    }

    await getContactData();
  },
  { immediate: true },
);

const displayedTitle = computed(() => {
  if (props.title === "")
    return `${contactData.value?.firstNames} ${contactData.value?.lastName} (${props.contactId})`;
  return `${props.title} (${props.contactId})`;
});

const emailContact = () => {
  if (!contactData.value?.email) {
    return;
  }

  window.open(`mailto:${contactData.value.email}`);
};

const telephoneContact = (telephoneNumber: string | undefined) => {
  if (!telephoneNumber) {
    return;
  }

  window.open(`tel:${telephoneNumber}`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(modalBase, {
    title: displayedTitle.value,
    modelValue: showPeek.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showPeek).value = $event)),
    showCloseButton: true
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(DxTextBox), {
            value: contactData.value?.email ?? '',
            readOnly: true
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DxButton), {
                name: "property-lookup",
                position: "after",
                options: {
                icon: 'email',
                stylingMode: 'text',
                type: 'dx-dropdowneditor-button',
                disabled: false,
                onClick: () => emailContact(),
              }
              }, null, 8, ["options"])
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(DxTextBox), {
            value: contactData.value?.mobileTelephone ?? '',
            readOnly: true
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DxButton), {
                name: "property-lookup",
                position: "after",
                options: {
                icon: 'tel',
                stylingMode: 'text',
                type: 'dx-dropdowneditor-button',
                disabled: false,
                onClick: () => telephoneContact(contactData.value?.mobileTelephone),
              }
              }, null, 8, ["options"])
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(DxTextBox), {
            value: contactData.value?.homeTelephone ?? '',
            readOnly: true
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DxButton), {
                name: "property-lookup",
                position: "after",
                options: {
                icon: 'tel',
                stylingMode: 'text',
                type: 'dx-dropdowneditor-button',
                disabled: false,
                onClick: () => telephoneContact(contactData.value?.homeTelephone),
              }
              }, null, 8, ["options"])
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_unref(DxTextBox), {
            value: contactData.value?.businessTelephone ?? '',
            readOnly: true
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DxButton), {
                name: "property-lookup",
                position: "after",
                options: {
                icon: 'tel',
                stylingMode: 'text',
                type: 'dx-dropdowneditor-button',
                disabled: false,
                onClick: () => telephoneContact(contactData.value?.businessTelephone),
              }
              }, null, 8, ["options"])
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_unref(DxTextBox), {
            value: contactData.value?.homeTelephoneAlt ?? '',
            readOnly: true
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DxButton), {
                name: "property-lookup",
                position: "after",
                options: {
                icon: 'tel',
                stylingMode: 'text',
                type: 'dx-dropdowneditor-button',
                disabled: false,
                onClick: () => telephoneContact(contactData.value?.homeTelephoneAlt),
              }
              }, null, 8, ["options"])
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Close',
          onClick: () => {
            closePeek();
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})